import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import moment from 'moment'
import Modal from 'react-responsive-modal'

class ViewPayment extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.refundType = [
      { label: 'Refund', value: 'refund' },
      { label: 'Cancellation', value: 'refund' }
    ]
    this.state = {
      selectedID: '',
      showModal: null,
      modem: 0,
      inventory: 0,
      receive_method: '',
      return_method: '',
      order_details: [],
      refund_value_limit: '',
      refundForm: {
        refund_type: '',
        refund_value: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  componentWillReceiveProps = ({ order }) => {
    const data = order.data_single
    let modem = 0
    let inventory = 0
    let receiveMethod = this.state.receive_method
    let returnMethod = this.state.return_method
    if (data.order_details) {
      data.order_details.map((item, i) => {
        if (item.type === 'modem') {
          receiveMethod = item.orderable.receive_method || ''
          returnMethod = item.orderable.return_method || ''
          modem++
        }

        if (item.type === "inventory") {
          receiveMethod = item.orderable.receive_method || ''
          inventory++
        }

        return true
      })
      this.setState({
        modem,
        inventory,
        order_details: data.order_details,
        receive_method: receiveMethod,
        return_method: returnMethod,
        refund_value_limit: data.final_amount
      })
    }
  }

  _fetchData = (id = this.props.order_id) => {
    this.props.getData(id)
  }

  _selectItem = (item, modalID) => {
    if (modalID) {
      this.setState({
        showModal: modalID,
        selectedID: item.id
      })
    }
  }

  _refundDana = (event, uuid) => {
    if (event) { event.preventDefault() }
    let form = { ...this.state.refundForm }
    let data = { uuid, form }
    this.props.refundDana(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  _toggleModal = (modalID) => {
    this.setState({ showModal: modalID })
  }

  _handleChange = (event, field) => {
    if (event) {
      event.preventDefault()
    }
    let refundForm = { ...this.state.refundForm }
    let value = event.target.value
    refundForm[field] = value
    this.setState({ refundForm })
  }

  render () {
    const { order } = this.props
    const data = order.data_single
    return (
      <div className='section' style={{ width: '80vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Order Payment Detail
            {(order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        {!(order.fetching || order.processing) && order.err &&
          <div className='alert alert-danger'>{order.err}</div>
        }
        <div className='title-block'>
          <div className='form-inline d-flex justify-content-between'>
            <div className='form-group'>
              <label className='control-label mr-2'>Unique Number</label>
              <label className={`badge badge-secondary`} style={{ fontSize: '100%' }}>
                { data.unique_number }
              </label>
            </div>
            <div className='form-group'>
              <label className='control-label mr-2'>Status</label>
              <label className={`badge badge-secondary`} style={{ fontSize: '100%' }}>
                { data.status }
              </label>
            </div>
          </div>
        </div>

        <section className='section table-responsive'>
          <table className='table table-striped table-hover'>
            <thead>
              <tr>
                <th>Payment ID</th>
                <th>Payment method</th>
                <th>Payment status </th>
                <th>Create date package</th>
              </tr>
            </thead>
            <tbody>
              { data.order_payment
                ? <tr>
                  <td>{ data.order_payment.payment_id || '-' }</td>
                  <td>
                    { data.order_payment.payment_method || '-' }
                    {
                      data.order_payment.payment_method === 'virtual-account'
                        ? data.order_payment.payment_response.bank_name
                          ? ` (${data.order_payment.payment_response.bank_name})`
                          : ''
                        : ''
                    }
                    {
                      (data.order_payment.payment_method === 'DANA' && data.order_payment.payment_response !== null)
                        ? `(${data.order_payment.payment_response.payMethod})`
                        : ''
                    }
                  </td>
                  <td>
                    { data.order_payment.payment_status || '-' }
                    {
                      data.order_payment.payment_method === 'DANA' &&
                      (data.order_payment.payment_status === 'request-cancel' || data.order_payment.payment_status === 'success') &&
                      <button onClick={() => this._selectItem(data, 'refund')} className='ml-2 btn btn-sm btn-danger'><i className='mr-2 fa fa-share-square' />Refund</button>
                    }
                  </td>
                  <td>{ moment.unix(data.order_payment.created_at).format(this.dateFormat) }</td>
                </tr>
                : <tr>
                  <td colSpan='4' className='text-center'>- NO DATA -</td>
                </tr>
              }
            </tbody>
          </table>
        </section>

        {/* Bank Account Details */}
        { this.state.modem > 0 &&
          <div>
            <div className='title-block'>
              <h4>Bank Account Details</h4>
            </div>

            <section className='section table-responsive'>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th>Bank</th>
                    <th>Holder name</th>
                    <th>Holder account number</th>
                  </tr>
                </thead>
                <tbody>
                  { data.order_details
                    ? data.order_details.map((item, i) => {
                      if (item.type === 'modem') {
                        return (
                          <tr key={i}>
                            <td>{ item.orderable.order_detail_bank_account ? item.orderable.order_detail_bank_account.bank : '-' }</td>
                            <td>{ item.orderable.order_detail_bank_account ? item.orderable.order_detail_bank_account.holder_name : '-' }</td>
                            <td>{ item.orderable.order_detail_bank_account ? item.orderable.order_detail_bank_account.holder_account_number : '-' }</td>
                          </tr>
                        )
                      } else {
                        return null
                      }
                    })
                    : <tr>
                      <td colSpan='4' className='text-center'>- NO DATA -</td>
                    </tr>
                  }
                </tbody>
              </table>
            </section>

            {/* RECEIVE DETAILS */}
            <div className='title-block mb-2'>
              <h4>Receive Details</h4>
            </div>

            <span className='badge badge-info mb-2'><h5 className='mt-1'>{ this.state.receive_method || '-----' }</h5></span>
            {/* RECEIVE AIRPORT */}
            {this.state.receive_method === 'airport' &&
            <section className='section table-responsive'>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Estimate time from</th>
                    <th>Estimate time to</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.order_details.length
                      ? this.state.order_details.map((item, i) => {
                        if (item.type === 'modem' && item.orderable.receive_order_detail_airport) {
                          return (
                            <tr key={i}>
                              <td>{ item.orderable.receive_order_detail_airport.name || '-' }</td>
                              <td>{ item.orderable.receive_order_detail_airport.date || '-' }</td>
                              <td>{ item.orderable.receive_order_detail_airport.estimate_time_from || '-' }</td>
                              <td>{ item.orderable.receive_order_detail_airport.estimate_time_to || '-' }</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      })
                      : <tr>
                        <td colSpan='4' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </section>}

            {/* RECEIVE COURIER */}
            {this.state.receive_method === 'courier' &&
            <section className='section table-responsive'>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th>Address</th>
                    <th>Province</th>
                    <th>City</th>
                    <th>District</th>
                    <th>Sub District</th>
                    <th>Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.order_details.length
                      ? this.state.order_details.map((item, i) => {
                        if (item.type === 'modem' && item.orderable.receive_courier) {
                          return (
                            <tr key={i}>
                              <td>{ item.orderable.receive_courier.user_address.address || '-' }</td>
                              <td>{ item.orderable.receive_courier.user_address.province ? item.orderable.receive_courier.user_address.province.name : '-' }</td>
                              <td>{ item.orderable.receive_courier.user_address.city ? item.orderable.receive_courier.user_address.city.name : '-' }</td>
                              <td>{ item.orderable.receive_courier.user_address.district ? item.orderable.receive_courier.user_address.district.name : '-' }</td>
                              <td>{ item.orderable.receive_courier.user_address.subdistrict ? item.orderable.receive_courier.user_address.subdistrict.name : '-' }</td>
                              <td>{ item.orderable.receive_courier.user_address.postal_code || '-' }</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      })
                      : <tr>
                        <td colSpan='6' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </section>}
            {this.state.receive_method === 'vending-machine' &&
            <section className='section table-responsive'>
              {data.order_pickup && 
                <table className='table table-striped table-hover'>
                  <thead>
                    <tr>
                      <th>Kode</th>
                      <th>Pickup At</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{data.order_pickup.code || '-'}</td>
                      <td>{data.order_pickup.pickup_at ? moment.unix(data.order_pickup.pickup_at).format(this.dateFormat) : '-'}</td>
                      <td>{data.order_pickup.status ? 'Sudah Diambil' : 'Belum diambil'}</td>
                    </tr>
                  </tbody>
                </table>
              }
            </section>}

            {/* RETURN DETAILS */}
            <div className='title-block mb-2'>
              <h4>Return Details</h4>
            </div>

            <span className='badge badge-info mb-2'><h5 className='mt-1'>{ this.state.return_method || '-----' }</h5></span>
            {/* RETURN AIRPORT */}
            {this.state.return_method === 'airport' &&
            <section className='section table-responsive'>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Estimate time from</th>
                    <th>Estimate time to</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.order_details.length
                      ? this.state.order_details.map((item, i) => {
                        if (item.type === 'modem' && item.orderable.return_order_detail_airport) {
                          return (
                            <tr key={i}>
                              <td>{ item.orderable.return_order_detail_airport.name || '-' }</td>
                              <td>{ item.orderable.return_order_detail_airport.date || '-' }</td>
                              <td>{ item.orderable.return_order_detail_airport.estimate_time_from || '-' }</td>
                              <td>{ item.orderable.return_order_detail_airport.estimate_time_to || '-' }</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      }
                      )
                      : <tr>
                        <td colSpan='4' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </section>}
            {/* RETURN COURIER */}
            {this.state.return_method === 'courier' &&
            <section className='section table-responsive'>
              <table className='table table-striped table-hover'>
                <thead>
                  <tr>
                    <th>Address</th>
                    <th>Province</th>
                    <th>City</th>
                    <th>District</th>
                    <th>Sub District</th>
                    <th>Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.order_details.length
                      ? this.state.order_details.map((item, i) => {
                        if (item.type === 'modem' && item.orderable.return_courier) {
                          return (
                            <tr key={i}>
                              <td>{ item.orderable.return_courier.user_address.address || '-' }</td>
                              <td>{ item.orderable.return_courier.user_address.province ? item.orderable.return_courier.user_address.province.name : '-' }</td>
                              <td>{ item.orderable.return_courier.user_address.city ? item.orderable.return_courier.user_address.city.name : '-' }</td>
                              <td>{ item.orderable.return_courier.user_address.district ? item.orderable.return_courier.user_address.district.name : '-' }</td>
                              <td>{ item.orderable.return_courier.user_address.subdistrict ? item.orderable.return_courier.user_address.subdistrict.name : '-' }</td>
                              <td>{ item.orderable.return_courier.user_address.postal_code || '-' }</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      })
                      : <tr>
                        <td colSpan='6' className='text-center'>- NO DATA -</td>
                      </tr>
                  }
                </tbody>
              </table>
            </section>}
          </div>
        }

        { this.state.inventory > 0 &&
          <div>
            <div className='title-block mb-2'>
              <h5>Inventory Pickup Detail</h5>
            </div>
            <span className='badge badge-info mb-2'><h5 className='mt-1'>{ this.state.receive_method || '-----' }</h5></span>

            {this.state.receive_method === 'vending-machine' &&
            <section className='section table-responsive'>
              {data.order_pickup && 
                <table className='table table-striped table-hover'>
                  <thead>
                    <tr>
                      <th>Kode</th>
                      <th>Pickup At</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{data.order_pickup.code || '-'}</td>
                      <td>{data.order_pickup.pickup_at ? moment.unix(data.order_pickup.pickup_at).format(this.dateFormat) : '-'}</td>
                      <td>{data.order_pickup.status ? 'Sudah Diambil' : 'Belum diambil'}</td>
                    </tr>
                  </tbody>
                </table>
              }
            </section>}
          </div>
        }

        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
        </div>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'refund'} onClose={() => this._toggleModal(null)}>
          <section style={{ width: '45vw' }} >
            <div className='title-block'>
              <h1 className='title'>Confirm Refund</h1>
            </div>
            <div>
              <p className='text-center'>Please fill these details:</p>
            </div>
            <form onSubmit={(event) => this._refundDana(event, this.state.selectedID)}>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Refund Type</label>
                </div>
                <div className='col-9'>
                  <select defaultValue='' onChange={(event) => this._handleChange(event, 'refund_type')} required className='form-control'>
                    <option value='' disabled>- Select Refund Type -</option>
                    {
                      this.refundType.map((option, i) => (
                        <option key={i} value={option.value}>{option.label}</option>)
                      )
                    }
                  </select>
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Refund Amount</label>
                </div>
                <div className='col-9'>
                  <input placeholder='Fill refund amount' value={this.state.refundForm.refund_value} onChange={(event) => this._handleChange(event, 'refund_value')} required className='form-control' type='number' min={0} max={this.state.refund_value_limit} step={1} />
                </div>
              </div>
              <div className='text-right'>
                <button onClick={() => this._toggleModal(null)} className='btn btn-secondary' type='button'>
                  <i className='fa fa-times mr-2' />Cancel
                </button>
                <button type='submit' className='btn btn-primary ml-2'>
                  <i className='fa fa-check mr-2' />Confirm
                </button>
              </div>
            </form>
          </section>
        </Modal>

      </div>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  getData: (id) => dispatch(OrderActions.orderSingleRequest(id)),
  refundDana: (data) => dispatch(OrderActions.refundDanaRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewPayment)



// WEBPACK FOOTER //
// ./src/Containers/Order/ViewPayment.js